export default __webpack_public_path__ + "static/media/1210.20576313.png";